
export default function( settings )
{
    settings.slot.background = 'res/games/game_55/screen.png';
    settings.slot.underScreen = 'res/games/game_55/under_screen.png';
    settings.slot.underScreenPos = {x: 62, y: 126};
    settings.slot.symbol_animation_filename_pattern = 'res/games/game_55/balls/%d/55_%d';
    settings.slot.left_billets_on_filename_pattern = 'res/games/game_55/billets/pl%02d.png';
    settings.slot.right_billets_on_filename_pattern = 'res/games/game_55/billets/pl%02d.png';
    settings.slot.balls = 'res/games/game_55/balls/{symbol}/55_{symbol}_%03d.png';
    settings.slot.lines_pattern = 'res/games/game_55/lines/line_%02d.png';
    settings.slot.frames_template = 'res/games/game_55/frames/c%02d.png';
    settings.slot.systemaTextColor = 0xffe08b;
    settings.slot.terminalTextColor = 0xffe08b;

    settings.table.background = 'res/games/game_55/table/background.png';
    settings.table.combinationNameFormat = 'res/games/game_55/table/comby%02d.png';
    settings.table.coloursCircleNameFormat = 'res/games/game_55/cheque/colours_circul/c%02d.png';
    settings.table.frameNameFormat = 'res/games/game_55/table/rc%02d.png';
    settings.table.scatterPrice = {
        wins:[3,4,5],
        position:{x:1124, y:391}
    };

    settings.table.frameYPos = [ 211, 270, 329, 388, 477, 536, 595 ];
    settings.table.priceTable = [
        {
            symbol:0,
            wins:[3,4,5],
            position:{x:937, y:214}
        },
        {
            symbol:1,
            wins:[3,4,5],
            position:{x:1124, y:214}
        },
        {
            symbol:2,
            wins:[3,4,5],
            position:{x:937, y:273}
        },
        {
            symbol:3,
            wins:[3,4,5],
            position:{x:1124, y:273}
        },
        {
            symbol:4,
            wins:[3,4,5],
            position:{x:937, y:332}
        },
        {
            symbol:5,
            wins:[3,4,5],
            position:{x:1124, y:332}
        },
        {
            symbol:6,
            wins:[3,4,5],
            position:{x:937, y:391}
        },
    ];

    settings.slot.left_billets_coords = [
        {x:12, y:390},
        {x:12, y:195},
        {x:12, y:585},
        {x:12, y:130},
        {x:12, y:650},
        {x:12, y:325},
        {x:12, y:455},
        {x:12, y:260},
        {x:12, y:520},
    ];
    settings.slot.right_billets_coords = [
        {x:1142, y:390},
        {x:1142, y:195},
        {x:1142, y:585},
        {x:1142, y:130},
        {x:1142, y:650},
        {x:1142, y:325},
        {x:1142, y:455},
        {x:1142, y:520},
        {x:1142, y:260},
    ];
    settings.slot.lines_position = [
        [ 44, 402 ],
        [ 44, 209 ],
        [ 44, 597 ],
        [ 44, 145 ],
        [ 44, 205 ],
        [ 44, 338 ],
        [ 44, 169 ],
        [ 44, 274 ],
        [ 44, 272 ],
    ];
    settings.help.pages = 19;
    settings.help.pageNameFormat = "res/games/game_55/help/%02d.png";

    settings.texts.imgMain = 'res/games/game_55/game_text.png';
    settings.texts.imgRisk = 'res/games/game_55/risk_text.png';

    settings.risk.background = 'res/games/game_55/risk/risk_screen.png';
    settings.risk.redButton.state.normal = 'res/games/game_55/risk/red_button.png';
    settings.risk.redButton.state.over = 'res/games/game_55/risk/red_button.png';
    settings.risk.redButton.state.pressed = 'res/games/game_55/risk/red_button.png';
    settings.risk.redButton.state.disabled = 'res/games/game_55/risk/red_button.png';
    settings.risk.redButton.position = { x : 135, y : 407 };
    settings.risk.blackButton.state.normal = 'res/games/game_55/risk/blue_button.png';
    settings.risk.blackButton.state.over = 'res/games/game_55/risk/blue_button.png';
    settings.risk.blackButton.state.pressed = 'res/games/game_55/risk/blue_button.png';
    settings.risk.blackButton.state.disabled = 'res/games/game_55/risk/blue_button.png';
    settings.risk.blackButton.position = { x : 790, y : 407 };
    settings.risk.history.cardOffset = 94;
    settings.risk.currentWinLabel.font = 'risk_result_font_game_55';
    settings.risk.nextWinLabel.font = 'risk_result_font_game_55';
    settings.risk.nextWinLabel.align = 'left';
    settings.risk.nextWinLabel.position = { x : 1083, y : 243 };
    settings.risk.currentStepLabel.font = 'risk_step_font_game_55';
    settings.risk.stepsLabel.font = 'risk_step_font_game_55';

    settings.ui.buttons.spin.frames.normal = 'res/games/game_55/ui/rezultat_on.png';
    settings.ui.buttons.spin.frames.disabled = 'res/games/game_55/ui/rezultat_of.png';
    settings.ui.buttons.collect.frames.normal = 'res/games/game_55/ui/rezultat_on.png';
    settings.ui.buttons.collect.frames.disabled = 'res/games/game_55/ui/rezultat_of.png';
    settings.ui.buttons.finish.frames.normal = 'res/games/game_55/ui/exit_pari_of.png';
    settings.ui.buttons.finish.frames.disabled = 'res/games/game_55/ui/exit_pari_of.png';
    settings.ui.buttons.end_pari.frames.normal = 'res/games/game_55/ui/exit_pari_of.png';
    settings.ui.buttons.end_pari.frames.disabled = 'res/games/game_55/ui/exit_pari_of.png';
    settings.ui.buttons.gamble.frames.normal = 'res/games/game_55/ui/auto_on.png';
    settings.ui.buttons.gamble.frames.disabled = 'res/games/game_55/ui/auto_of.png';
    settings.ui.buttons.risk_red.frames.normal = 'res/games/game_55/ui/red_on.png';
    settings.ui.buttons.risk_red.frames.disabled = 'res/games/game_55/ui/red_of.png';
    settings.ui.buttons.risk_black.frames.normal = 'res/games/game_55/ui/black_on.png';
    settings.ui.buttons.risk_black.frames.disabled = 'res/games/game_55/ui/black_of.png';
    settings.ui.buttons.next.frames.normal = 'res/games/game_55/ui/next_on.png';
    settings.ui.buttons.next.frames.disabled = 'res/games/game_55/ui/next_of.png';
    settings.ui.buttons.back.frames.normal = 'res/games/game_55/ui/prev_on.png';
    settings.ui.buttons.back.frames.disabled = 'res/games/game_55/ui/prev_of.png';
    settings.ui.buttons.exit.frames.normal =  'res/games/game_55/ui/help_back_off.png';
    settings.ui.buttons.exit.frames.disabled =  'res/games/game_55/ui/help_back_on.png';


    settings.ui.buttons.info.position =  {x : 1048, y : 5 };
    settings.ui.buttons.menu.position =  {x : 1187, y : 759 };
    settings.ui.buttons.linebet.position =  {x : 1187, y : 823 };
    settings.ui.buttons.autoplay.position =  {x : 1317, y : 761 };
    settings.ui.buttons.autoplayoff.position =  {x : 1317, y : 761 };
    settings.ui.buttons.start.position =  {x : 1317, y : 761 };
    settings.ui.buttons.gamble.position =  {x : 1317, y : 761 };
    settings.ui.buttons.spin.position =  {x : 1448, y : 761 };
    settings.ui.buttons.collect.position =  {x : 1448, y : 761 };
    settings.ui.buttons.next.position =  {x : 795, y : 814 };
    settings.ui.buttons.back.position =  {x : 663, y : 814 };
    settings.ui.buttons.exit.position =  {x : 25, y : 814 };


    settings.ui.buttons.autoplay.frames.normal = 'res/games/game_55/ui/auto_on.png';
    settings.ui.buttons.autoplay.frames.disabled = 'res/games/game_55/ui/auto_of.png';
    settings.ui.buttons.autoplayoff.frames.normal = 'res/games/game_55/ui/auto_on.png';
    settings.ui.buttons.autoplayoff.frames.disabled = 'res/games/game_55/ui/auto_of.png';
    settings.ui.buttons.menu.frames.normal = 'res/games/game_55/ui/menu_on.png';
    settings.ui.buttons.menu.frames.disabled = 'res/games/game_55/ui/menu_of.png';
    settings.ui.buttons.linebet.frames.normal = 'res/games/game_55/ui/size_step_on.png';
    settings.ui.buttons.linebet.frames.disabled = 'res/games/game_55/ui/size_step_of.png';
    settings.ui.buttons.visual_mode.frames.normal = 'res/games/game_55/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_55/ui/visual_mode_of.png';
    settings.ui.buttons.visual_mode.frames.normal = 'res/games/game_55/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_55/ui/visual_mode_of.png';
    settings.ui.buttons.info.frames.normal = 'res/games/game_55/ui/info_on.png';
    settings.ui.buttons.info.frames.disabled = 'res/games/game_55/ui/info_of.png';


    settings.smallTicket.miniballsNameFormat = 'res/games/game_55/small_ticket/miniballs/mb%02d.png';
    settings.smallTicket.balls_screen = 'res/games/game_55/small_ticket/balls_screen.png';
    settings.smallTicket.lines_choice = 'res/games/game_55/small_ticket/sat_%02d.png';
    settings.smallTicket.risk_template = 'res/games/game_55/small_ticket/risk_screen%02d.png';

    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings,

        //name для удобства чтения логов на сервере:
        name : 'game_55',
        //идентификатор математики на сервере:
        id : 582,

        reactive,

        graphics : [

            //small ticket:
            'res/games/game_55/small_ticket/balls_screen.png',
            'res/games/game_55/small_ticket/risk_screen00.png',
            'res/games/game_55/small_ticket/risk_screen01.png',
            'res/games/game_55/small_ticket/sat_01.png',
            'res/games/game_55/small_ticket/sat_02.png',
            'res/games/game_55/small_ticket/sat_03.png',
            'res/games/game_55/small_ticket/sat_04.png',
            'res/games/game_55/small_ticket/sat_05.png',
            'res/games/small_ticket/small_ticket_digits.xml',
            'res/games/game_55/small_ticket/miniballs/mb00.png',
            'res/games/game_55/small_ticket/miniballs/mb01.png',
            'res/games/game_55/small_ticket/miniballs/mb02.png',
            'res/games/game_55/small_ticket/miniballs/mb03.png',
            'res/games/game_55/small_ticket/miniballs/mb04.png',
            'res/games/game_55/small_ticket/miniballs/mb05.png',
            'res/games/game_55/small_ticket/miniballs/mb06.png',
            'res/games/game_55/small_ticket/miniballs/mb07.png',
            'res/games/game_55/small_ticket/miniballs/mb08.png',

            //help:
            'res/games/game_55/help/00.png',
            'res/games/game_55/help/01.png',
            'res/games/game_55/help/02.png',
            'res/games/game_55/help/03.png',
            'res/games/game_55/help/04.png',
            'res/games/game_55/help/05.png',
            'res/games/game_55/help/06.png',
            'res/games/game_55/help/07.png',
            'res/games/game_55/help/08.png',
            'res/games/game_55/help/09.png',
            'res/games/game_55/help/10.png',
            'res/games/game_55/help/11.png',
            'res/games/game_55/help/12.png',
            'res/games/game_55/help/13.png',
            'res/games/game_55/help/14.png',
            'res/games/game_55/help/15.png',
            'res/games/game_55/help/16.png',
            'res/games/game_55/help/17.png',
            'res/games/game_55/help/18.png',

            //risk:
            'res/games/risk/masti/bubi.png',
            'res/games/risk/masti/piki.png',
            'res/games/risk/black_ball.png',
            'res/games/game_55/risk/blue_button.png',
            'res/games/risk/card_black.png',
            'res/games/risk/card_red.png',
            'res/games/risk/red_ball.png',
            'res/games/game_55/risk/red_button.png',
            'res/games/game_55/risk/risk_screen.png',
            'res/games/risk/rubaska_big/rbb.png',
            'res/games/risk/rubaska_big/rbr.png',
            'res/games/game_55/risk/risk_result_font_game_55.xml',
            'res/games/game_55/risk/risk_step_font_game_55.xml',

            //table:
            'res/games/game_55/table/background.png',
            'res/games/table/coeff_tab_digits.xml',
            'res/games/game_55/table/comby00.png',
            'res/games/game_55/table/comby01.png',
            'res/games/game_55/table/comby02.png',
            'res/games/game_55/table/comby03.png',
            'res/games/game_55/table/comby04.png',
            //cheque:
            'res/games/cheque/chek.png',
            'res/games/cheque/digits_ishod.xml',
            'res/games/game_55/cheque/colours_circul/c00.png',
            'res/games/game_55/cheque/colours_circul/c01.png',
            'res/games/game_55/cheque/colours_circul/c02.png',
            'res/games/game_55/cheque/colours_circul/c03.png',
            'res/games/game_55/cheque/colours_circul/c04.png',
            'res/games/game_55/cheque/colours_circul/c05.png',
            'res/games/game_55/cheque/colours_circul/c06.png',
            'res/games/game_55/cheque/colours_circul/c07.png',
            'res/games/game_55/cheque/colours_circul/c08.png',
            'res/games/game_55/table/rc00.png',
            'res/games/game_55/table/rc01.png',
            'res/games/game_55/table/rc02.png',
            'res/games/game_55/table/rc03.png',
            'res/games/game_55/table/rc04.png',
            'res/games/game_55/table/rc05.png',
            'res/games/game_55/table/rc06.png',
            'res/games/game_55/table/rc07.png',
            'res/games/game_55/table/rc08.png',

            //ui:
            'res/games/ui/yello_dig.xml',
            'res/games/game_55/ui/auto_of.png',
            'res/games/game_55/ui/auto_on.png',
            'res/games/game_55/ui/black_of.png',
            'res/games/game_55/ui/black_on.png',
            'res/games/game_55/ui/exit_pari_of.png',
            'res/games/game_55/ui/exit_pari_on.png',
            'res/games/game_55/ui/menu_of.png',
            'res/games/game_55/ui/menu_on.png',
            'res/games/game_55/ui/red_of.png',
            'res/games/game_55/ui/red_on.png',
            'res/games/game_55/ui/rezultat_of.png',
            'res/games/game_55/ui/rezultat_on.png',
            'res/games/game_55/ui/size_step_on.png',
            'res/games/game_55/ui/size_step_of.png',
            'res/games/game_55/ui/visual_mode_of.png',
            'res/games/game_55/ui/visual_mode_on.png',
            'res/games/game_55/ui/info_of.png',
            'res/games/game_55/ui/info_on.png',
            'res/games/game_55/ui/next_of.png',
            'res/games/game_55/ui/next_on.png',
            'res/games/game_55/ui/prev_of.png',
            'res/games/game_55/ui/prev_on.png',
            'res/games/game_55/ui/help_back_off.png',
            'res/games/game_55/ui/help_back_on.png',

            'res/games/game_55/screen.png',
            'res/games/game_55/under_screen.png',
            'res/games/game_55/game_text.png',
            'res/games/game_55/risk_text.png',

            'res/games/game_55/billets/pl00.png',
            'res/games/game_55/billets/pl01.png',
            'res/games/game_55/billets/pl02.png',
            'res/games/game_55/billets/pl03.png',
            'res/games/game_55/billets/pl04.png',
            'res/games/game_55/billets/pl05.png',
            'res/games/game_55/billets/pl06.png',
            'res/games/game_55/billets/pl07.png',
            'res/games/game_55/billets/pl08.png',

            'res/games/game_55/frames/c00.png',
            'res/games/game_55/frames/c01.png',
            'res/games/game_55/frames/c02.png',
            'res/games/game_55/frames/c03.png',
            'res/games/game_55/frames/c04.png',
            'res/games/game_55/frames/c05.png',
            'res/games/game_55/frames/c06.png',
            'res/games/game_55/frames/c07.png',
            'res/games/game_55/frames/c08.png',

            'res/games/game_55/lines/line_00.png',
            'res/games/game_55/lines/line_01.png',
            'res/games/game_55/lines/line_02.png',
            'res/games/game_55/lines/line_03.png',
            'res/games/game_55/lines/line_04.png',
            'res/games/game_55/lines/line_05.png',
            'res/games/game_55/lines/line_06.png',
            'res/games/game_55/lines/line_07.png',
            'res/games/game_55/lines/line_08.png',

            'res/games/mini_balls/for_balls.png',
            'res/games/a1_a15.png',
            //потом займёмся упаковкой и прочим ;) (думаю даже вообще удастся как-то свести все эти игры под одну с маленькими отличиями) ...
            'res/games/mini_balls/0_00.png',
            'res/games/mini_balls/0_01.png',
            'res/games/mini_balls/0_02.png',
            'res/games/mini_balls/1_00.png',
            'res/games/mini_balls/1_01.png',
            'res/games/mini_balls/1_02.png',
            'res/games/mini_balls/2_00.png',
            'res/games/mini_balls/2_01.png',
            'res/games/mini_balls/2_02.png',
            'res/games/mini_balls/3_00.png',
            'res/games/mini_balls/3_01.png',
            'res/games/mini_balls/3_02.png',
            'res/games/mini_balls/4_00.png',
            'res/games/mini_balls/4_01.png',
            'res/games/mini_balls/4_02.png',
            'res/games/mini_balls/5_00.png',
            'res/games/mini_balls/5_01.png',
            'res/games/mini_balls/5_02.png',
            'res/games/mini_balls/6_00.png',
            'res/games/mini_balls/6_01.png',
            'res/games/mini_balls/6_02.png',
            'res/games/mini_balls/7_00.png',
            'res/games/mini_balls/7_01.png',
            'res/games/mini_balls/7_02.png',
            'res/games/mini_balls/8_00.png',
            'res/games/mini_balls/8_01.png',
            'res/games/mini_balls/8_02.png',
            'res/games/mini_balls/9_00.png',
            'res/games/mini_balls/9_01.png',
            'res/games/mini_balls/9_02.png',
            'res/games/mini_balls/10_00.png',
            'res/games/mini_balls/10_01.png',
            'res/games/mini_balls/10_02.png',
            'res/games/mini_balls/11_00.png',
            'res/games/mini_balls/11_01.png',
            'res/games/mini_balls/11_02.png',
            'res/games/mini_balls/12_00.png',
            'res/games/mini_balls/12_01.png',
            'res/games/mini_balls/12_02.png',
            'res/games/mini_balls/black_01.png',
            'res/games/mini_balls/red_01.png',

            'res/games/game_55/balls/0/55_0_000.png',
            'res/games/game_55/balls/0/55_0_001.png',
            'res/games/game_55/balls/0/55_0_002.png',
            'res/games/game_55/balls/0/55_0_003.png',
            'res/games/game_55/balls/0/55_0_004.png',
            'res/games/game_55/balls/0/55_0_005.png',
            'res/games/game_55/balls/0/55_0_006.png',
            'res/games/game_55/balls/0/55_0_007.png',
            'res/games/game_55/balls/0/55_0_008.png',
            'res/games/game_55/balls/1/55_1_000.png',
            'res/games/game_55/balls/1/55_1_001.png',
            'res/games/game_55/balls/1/55_1_002.png',
            'res/games/game_55/balls/1/55_1_003.png',
            'res/games/game_55/balls/1/55_1_004.png',
            'res/games/game_55/balls/1/55_1_005.png',
            'res/games/game_55/balls/1/55_1_006.png',
            'res/games/game_55/balls/1/55_1_007.png',
            'res/games/game_55/balls/1/55_1_008.png',
            'res/games/game_55/balls/2/55_2_000.png',
            'res/games/game_55/balls/2/55_2_001.png',
            'res/games/game_55/balls/2/55_2_002.png',
            'res/games/game_55/balls/2/55_2_003.png',
            'res/games/game_55/balls/2/55_2_004.png',
            'res/games/game_55/balls/2/55_2_005.png',
            'res/games/game_55/balls/2/55_2_006.png',
            'res/games/game_55/balls/2/55_2_007.png',
            'res/games/game_55/balls/2/55_2_008.png',
            'res/games/game_55/balls/3/55_3_000.png',
            'res/games/game_55/balls/3/55_3_001.png',
            'res/games/game_55/balls/3/55_3_002.png',
            'res/games/game_55/balls/3/55_3_003.png',
            'res/games/game_55/balls/3/55_3_004.png',
            'res/games/game_55/balls/3/55_3_005.png',
            'res/games/game_55/balls/3/55_3_006.png',
            'res/games/game_55/balls/3/55_3_007.png',
            'res/games/game_55/balls/3/55_3_008.png',
            'res/games/game_55/balls/4/55_4_000.png',
            'res/games/game_55/balls/4/55_4_001.png',
            'res/games/game_55/balls/4/55_4_002.png',
            'res/games/game_55/balls/4/55_4_003.png',
            'res/games/game_55/balls/4/55_4_004.png',
            'res/games/game_55/balls/4/55_4_005.png',
            'res/games/game_55/balls/4/55_4_006.png',
            'res/games/game_55/balls/4/55_4_007.png',
            'res/games/game_55/balls/4/55_4_008.png',
            'res/games/game_55/balls/5/55_5_000.png',
            'res/games/game_55/balls/5/55_5_001.png',
            'res/games/game_55/balls/5/55_5_002.png',
            'res/games/game_55/balls/5/55_5_003.png',
            'res/games/game_55/balls/5/55_5_004.png',
            'res/games/game_55/balls/5/55_5_005.png',
            'res/games/game_55/balls/5/55_5_006.png',
            'res/games/game_55/balls/5/55_5_007.png',
            'res/games/game_55/balls/5/55_5_008.png',
            'res/games/game_55/balls/6/55_6_000.png',
            'res/games/game_55/balls/6/55_6_001.png',
            'res/games/game_55/balls/6/55_6_002.png',
            'res/games/game_55/balls/6/55_6_003.png',
            'res/games/game_55/balls/6/55_6_004.png',
            'res/games/game_55/balls/6/55_6_005.png',
            'res/games/game_55/balls/6/55_6_006.png',
            'res/games/game_55/balls/6/55_6_007.png',
            'res/games/game_55/balls/6/55_6_008.png',
            'res/games/game_55/balls/7/55_7_000.png',
            'res/games/game_55/balls/7/55_7_001.png',
            'res/games/game_55/balls/7/55_7_002.png',
            'res/games/game_55/balls/7/55_7_003.png',
            'res/games/game_55/balls/7/55_7_004.png',
            'res/games/game_55/balls/7/55_7_005.png',
            'res/games/game_55/balls/7/55_7_006.png',
            'res/games/game_55/balls/7/55_7_007.png',
            'res/games/game_55/balls/7/55_7_008.png',

            
            //common:
            'res/games/preloader.png',
        ],
        sounds : [],
    }
}

function reactive( { space, container } ) {
    //тут можно изменять space типа space.s( 'stream' ).alter() или добавлять что-то в container ...
}



// WEBPACK FOOTER //
// ./src/games/game_55.es6